import Endpoints from 'constants/Endpoints';
import {clearResource, setResource, setSaveStatusDialog, setSaveStatusError, setSaveStatusLoading} from 'redux/actions'
import reduxStore from 'redux/store'
import {RestRequestBLOB, RestRequestDELETE, RestRequestGET, RestRequestPOST, RestRequestPUT} from 'libs/RestRequest';
import validateSection from './helpers/validateSection'
import Tr from "../translations/Translations";
import downloadFileWithPreloadUrl from "libs/downloadFileWithPreloadUrl";
import {SiwzSourceType} from "../components/complex/documentsTables/swz/constants/SiwzSourceType";
import RepoService from "./RepoService";
import isResponseValid from "libs/isResponseValid";

const __get = async (url, resourcesName) => {
    try {
        const res = await RestRequestGET(url);

        reduxStore.dispatch(
            setResource(resourcesName, res)
        )
    } catch (error) {
    }
}

const SIWZ_TYPE_LIST_RESOURCE_ID = "typeSiwzList";
const SIWZ_LIST_RESOURCE_ID = "siwzList";
const SIWZ_EDITABLE_RESOURCE_ID = "siwzEditable";


const send = async (demandId, files, demandValidationSectionId) => {

    let list = []
    files.forEach(x => {
        list.push({
            repositoryId: x.identity,
            type: x.type,
            description: "",
            parentSiwzId: x.parent,
            publish: x.autopublish
        })
    });

    const data = {
        "list": list
    }

    const addResp = await RestRequestPOST(Endpoints.SIWZ(demandId), data);
    await updateAfterAdd(demandId, addResp, demandValidationSectionId);
}

const moveFromRepo = async (demandId, files, demandValidationSectionId) => {
    const list = []
    files.forEach(x => {
        list.push({
            repositoryId: x.identity,
            type: x.type,
            description: "",
            parentSiwzId: x.parent,
            publish: x.autopublish
        });
    });
    const data = {
        "list": list
    }

    const addResp = await RestRequestPOST(Endpoints.SIWZ_MOVE_FROM_REPO(demandId), data);
    await updateAfterAdd(demandId, addResp, demandValidationSectionId);
}

const updateAfterAdd = async (demandId, addResp, demandValidationSectionId) => {
    //jeśli któryś z dodanych plików miał wyższą wersję musze przeładowac wszystko
    if (addResp.findIndex(x => x.version > 1) > -1) {
        await getList(demandId);
    } else {
        const {resources} = reduxStore.getState();
        const newList = [...addResp.reverse(), ...resources[SIWZ_LIST_RESOURCE_ID]];
        reduxStore.dispatch(setResource(SIWZ_LIST_RESOURCE_ID, newList));
    }

    if (demandValidationSectionId)
        await validateSection(demandValidationSectionId, demandId, false);
}


const addBzpNotice = async (demandId, bzpNoticeId, siwzType) => {
    const url = Endpoints.SIWZ_ADD_BZP_NOTICE(demandId)

    const data = {
        bzpNoticeId,
        siwzType
    }

    return await RestRequestPOST(url, data);
}

const deleteItem = async (demandId, {identity, source, rootIdentity}, demandValidationSectionId) => {
    const resp = await RestRequestDELETE(Endpoints.SIWZ_ID(demandId, identity, source));
    try {
        if (resp.success) {

            const {resources} = reduxStore.getState();
            const curList = resources[SIWZ_LIST_RESOURCE_ID];
            const itemToRemove = curList.find(siwz => siwz.identity === identity && siwz.source === source);

            if (itemToRemove.version === 1) {
                reduxStore.dispatch(setResource(SIWZ_LIST_RESOURCE_ID, curList.filter(siwz => !(siwz.identity === identity && siwz.source === source))));
            } else {
                await getList(demandId);
            }

            if (source === SiwzSourceType.REPO) {
                RepoService.updateTrash(demandId)
            }

            if (demandValidationSectionId)
                await validateSection(demandValidationSectionId, demandId, false);
        } else {
            throw new Error(resp);
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
}

const publish = async (demandId, {identity, source, rootIdentity}, demandValidationSectionId) => {
    const resp = await RestRequestPUT(Endpoints.SIWZ_ID_PUBLISH(demandId, identity, source));
    try {
        if (resp.success) {
            updateSiwzRowInStore(resp.result, true, rootIdentity);
            if (demandValidationSectionId)
                await validateSection(demandValidationSectionId, demandId, false);
        } else {
            throw new Error(resp);
        }
    } catch (e) {
        console.error(e);
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
}

const unpublish = async (demandId, {identity, source, rootIdentity}, demandValidationSectionId) => {
    const resp = await RestRequestPUT(Endpoints.SIWZ_ID_UNPUBLISH(demandId, identity, source));
    try {
        if (resp.success) {
            updateSiwzRowInStore(resp.result, true, rootIdentity)
            if (demandValidationSectionId)
                await validateSection(demandValidationSectionId, demandId, false);
        } else {
            throw new Error(resp);
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
}

const getDownloadHistory = async (demandId, {identity, source, rootIdentity}, pagination) => {

    const params = {
        ...pagination
    }

    const url = Endpoints.SIWZ_ID_DOWNLOAD_HISTORY(demandId, identity, source);
    const siwzDownloadHistory = await RestRequestGET(url, {params});
    return siwzDownloadHistory;
}

const getVersions = async (demandId, {identity, source}) => {
    const url = Endpoints.SIWZ_ID_VERSIONS(demandId, identity, source);
    const resp = await RestRequestGET(url);

    const {resources} = reduxStore.getState();
    const siwzList = resources[SIWZ_LIST_RESOURCE_ID].map((x) => {
        if (x.identity === identity) {
            return {...x, versions: resp.filter(x => x.identity !== identity)};
        } else {
            return x;
        }
    });
    reduxStore.dispatch(setResource(SIWZ_LIST_RESOURCE_ID, siwzList));
}

const clearVersions = async (demandId, {identity, source}) => {
    const {resources} = reduxStore.getState();
    const siwzList = resources[SIWZ_LIST_RESOURCE_ID].map((x) => {
        if (x.identity === identity) {
            return {...x, versions: undefined};
        } else {
            return x;
        }
    });
    reduxStore.dispatch(setResource(SIWZ_LIST_RESOURCE_ID, siwzList));
}

const deleteAll = async (demandId, demandValidationSectionId) => {
    const url = Endpoints.SIWZ(demandId);
    await RestRequestDELETE(url);
    reduxStore.dispatch(setResource(SIWZ_LIST_RESOURCE_ID, []));
    if (demandValidationSectionId)
        await validateSection(demandValidationSectionId, demandId);
}

const getList = async (demandId) => {
    await __get(Endpoints.SIWZ(demandId), SIWZ_LIST_RESOURCE_ID)
}

const getTypes = async (demandId) => {
    await __get(Endpoints.SIWZ_TYPES(demandId), SIWZ_TYPE_LIST_RESOURCE_ID)
}

const downloadAll = async (demandId) => {
    await RestRequestBLOB(Endpoints.SIWZ_DOWNLOAD_ALL(demandId))
}


const save = async (demandId, demandValidationSectionId) => {
    reduxStore.dispatch(setSaveStatusLoading());
    if (demandValidationSectionId)
        await validateSection(demandValidationSectionId, demandId);
    reduxStore.dispatch(setSaveStatusDialog());
}

const validateSIWZ = async (demandId) => {
    return RestRequestGET(Endpoints.SIWZ_VALIDATE(demandId));
}

const validateDocuments = async (demandId) => {
    return RestRequestGET(Endpoints.SIWZ_VALIDATE_DOCUMENTS(demandId));
}

const updateSiwzRowInStore = (siwzRow, preserveVersions, rootRowIdentity) => {
    const {resources} = reduxStore.getState();

    const rootRowId = rootRowIdentity ? rootRowIdentity : siwzRow.identity;
    const versionRowId = rootRowIdentity ? siwzRow.identity : null;

    const siwzList = resources[SIWZ_LIST_RESOURCE_ID].map((x) => {
        if (x.identity === rootRowId) {
            if (versionRowId) {
                if (x.versions) {
                    const versions = x.versions.map((r) => {
                        if (r.identity === versionRowId)
                            return siwzRow
                        else
                            return r
                    });
                    return {...x, versions}
                } else {
                    return {...x};
                }
            } else {
                if (preserveVersions) {
                    siwzRow.versions = x.versions;
                }
                return siwzRow;
            }
        } else {
            return x;
        }

    });
    reduxStore.dispatch(setResource(SIWZ_LIST_RESOURCE_ID, siwzList));
}

const updateDescription = async (demandId, {identity, source, rootIdentity}, description) => {
    const resp = await RestRequestPUT(Endpoints.SIWZ_ID_UPDATE_DESCRIPTION(demandId, identity, source), {description});
    try {
        if (resp.success) {
            updateSiwzRowInStore(resp.result, true, rootIdentity)
        } else {
            throw new Error(resp);
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
}
const updateNoticeReferenceNumber = async (demandId, {identity, source, rootIdentity}, noticeReferenceNumber) => {
    const resp = await RestRequestPUT(Endpoints.SIWZ_ID_UPDATE_NOTICE_REFERENCE_NUMBER(demandId, identity, source), {noticeReferenceNumber});
    try {
        if (resp.success) {
            updateSiwzRowInStore(resp.result, true, rootIdentity)
        } else {
            throw new Error(resp);
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
}
const shareSiwz = async (demandId, {identity, source, rootIdentity}, system) => {
    const resp = await RestRequestPOST(Endpoints.SIWZ_ID_UPDATE_SHARE(demandId, identity, source), {system});
    try {
        if (isResponseValid(resp, (e) => reduxStore.dispatch(setSaveStatusError(e)))) {
            return true;
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
    return false;
}

const getDownloadFile = async (demandId, {identity, source, rootIdentity}, openInBrowser) => {
    await downloadFileWithPreloadUrl(
        Endpoints.SIWZ_ID_GET_DOWNLOAD_URL(demandId, identity, source, openInBrowser),
        openInBrowser);
}

const generateSWZ = (demandId, arr, finallyCallback = () => {
}) => {
    const data = {
        list: arr
    }
    RestRequestBLOB(Endpoints.SIWZ_POST_PRINT_SWZ(demandId), {method: 'post', data: data})
        .finally(finallyCallback);
}

const shareGenerateSWZ = async (demandId, arr, shareSystem) => {
    const data = {
        list: arr
    }
    const params = {
        shareSystem
    }
    try {
        const resp = await RestRequestPOST(Endpoints.SIWZ_POST_SHARE_SWZ(demandId), data, {params})
        if (isResponseValid(resp, (e) => reduxStore.dispatch(setSaveStatusError(e)))) {
            return resp.success;
        }
    } catch (e) {
        console.error(e);
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
    return false;


}

const isSiwzEditable = async (demandId) => {
    const resp = await RestRequestGET(Endpoints.SIWZ_EDITABLE(demandId));
    reduxStore.dispatch(setResource(SIWZ_EDITABLE_RESOURCE_ID, resp));
}

const buildSiwzIdentity = (identity, source, rootIdentity = null) => {
    return {identity, source, rootIdentity};
}
const clearResources = (id) => {
    reduxStore.dispatch(clearResource(id));
}

export default {
    save,
    validateSIWZ,
    validateDocuments,
    getList,
    getTypes,
    send,
    moveFromRepo,
    deleteItem,
    deleteAll,
    downloadAll,
    unpublish,
    publish,
    getDownloadHistory,
    getVersions,
    clearVersions,
    updateDescription,
    updateNoticeReferenceNumber,
    addBzpNotice,
    generateSWZ,
    shareGenerateSWZ,
    shareSiwz,
    getDownloadFile,
    isSiwzEditable,
    buildSiwzIdentity,
    clearResources,
    SIWZ_LIST_RESOURCE_ID,
    SIWZ_TYPE_LIST_RESOURCE_ID,
    SIWZ_EDITABLE_RESOURCE_ID
}